import React from 'react';
import { motion } from 'framer-motion';
import { Phone } from 'lucide-react';
import { SITE, waLink } from '@/config';
import { trackEvent } from '@/lib/tracking';
import { WhatsAppIcon } from '@/components/CTAButtons';

const ContactIslands = () => {
  return (
    <>
      {/* Desktop floating islands */}
      <div className="hidden md:flex fixed right-5 bottom-8 z-[70] flex-col gap-3" data-testid="desktop-contact-islands">
        <motion.a
          href={waLink()} target="_blank" rel="noopener noreferrer"
          data-testid="floating-whatsapp-btn"
          onClick={() => trackEvent('whatsapp_click', { from: 'floating' })}
          initial={{ opacity: 0, x: 40 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 1, duration: 0.5 }}
          className="flex items-center gap-2 rounded-full bg-[#1FAF54] text-white pl-4 pr-5 py-3 text-sm font-semibold shadow-xl hover:bg-[#178f43] hover:-translate-y-0.5 transition-all"
        >
          <WhatsAppIcon className="h-5 w-5" /> WhatsApp
        </motion.a>
        <motion.a
          href={SITE.tel}
          data-testid="floating-call-btn"
          onClick={() => trackEvent('phone_click', { from: 'floating' })}
          initial={{ opacity: 0, x: 40 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 1.15, duration: 0.5 }}
          className="flex items-center gap-2 rounded-full bg-palm text-ivory pl-4 pr-5 py-3 text-sm font-semibold shadow-xl hover:bg-palm-2 hover:-translate-y-0.5 transition-all"
        >
          <Phone className="h-5 w-5" /> Call Now
        </motion.a>
      </div>

      {/* Mobile bottom conversion bar */}
      <div className="md:hidden fixed bottom-0 inset-x-0 z-[70] bg-palm/95 backdrop-blur-md border-t border-white/10 pb-[env(safe-area-inset-bottom)]" data-testid="mobile-contact-bar">
        <div className="grid grid-cols-3">
          <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="mobile-whatsapp-btn"
            onClick={() => trackEvent('whatsapp_click', { from: 'mobile_bar' })}
            className="flex items-center justify-center gap-2 py-4 text-[#4be07f] text-sm font-semibold">
            <WhatsAppIcon className="h-4 w-4" /> WhatsApp
          </a>
          <a href={SITE.tel} data-testid="mobile-call-btn"
            onClick={() => trackEvent('phone_click', { from: 'mobile_bar' })}
            className="flex items-center justify-center gap-2 py-4 text-ivory text-sm font-semibold border-x border-white/10">
            <Phone className="h-4 w-4" /> Call Now
          </a>
          <button type="button" data-testid="mobile-enquire-btn"
            onClick={() => window.dispatchEvent(new CustomEvent('open-enquiry'))}
            className="flex items-center justify-center gap-2 py-4 text-gold text-sm font-bold">
            Enquire
          </button>
        </div>
      </div>
    </>
  );
};

export default ContactIslands;
